/* eslint-disable no-useless-concat */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import {useTranslation} from 'react-i18next'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import DistributorCreate from './create/Distributor'
import AdminCreate from './create/Admin'
import { HakAkses } from 'src/components/mikro/getHakAkses'

const FinancialCreate: React.FC = () => {
  const {t} = useTranslation()
  const intl = useIntl()

  const hakAkses = HakAkses()
  const [roleUser, setRoleUser] = useState('')

  const getRole = () => {
    const role: any = localStorage.getItem('role-flag')
    setRoleUser(role)
  }

  useEffect(() => {
    getRole()
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {t('page findoc create')}
      </PageTitle>

      {
        (roleUser == 'null' || roleUser === '' || roleUser == null) ? <>
          <DistributorCreate/>
        </> : <>
          <AdminCreate/>
        </>
      }
    </>
  )
}

export {FinancialCreate}
